<template>
  <div class="mh bg-main idCard">
    <tip
      tips="为保证您的图片正常上传，请将您要上传的证件图片控制在10M以内，若图片过大，上传时请耐心等待！"
    />
    <div class="p10">
      <card-wrap>
        <template v-slot:title>
          <div class="cardTitle">
            上传身份证<span style="color: #d62d27">头像面</span>
          </div>
        </template>
        <div class="mt30 p0-40">
          <van-uploader
            class="uploader pb12"
            v-model="fileList1"
            :max-count="1"
            :after-read="onfrontRead"
            :accept="'image/*'"
            :max-size="10 * 1024 * 1024"
            :disabled="Boolean($route.query.disabled)"
            :deletable="!Boolean($route.query.disabled)" 
            @oversize="onOversize">
            <div class="uploadDemoP">
              <div class="uploadDemo">
                <img src="@/assets/img/touxiangmian@2x.png" alt="" />
              </div>
            </div>
          </van-uploader>
        </div>
      </card-wrap>
      <card-wrap class="mt8">
        <template v-slot:title>
          <div class="cardTitle">
            上传身份证<span style="color: #d62d27">国徽面</span>
          </div>
        </template>
        <div class="mt30 p0-40">
          <van-uploader
            class="uploader pb12"
            v-model="fileList2"
            :max-count="1"
            :after-read="onreverseSideRead"
            :accept="'image/*'"
            :max-size="10 * 1024 * 1024"
            :disabled="Boolean($route.query.disabled)"
            :deletable="!Boolean($route.query.disabled)" 
            @oversize="onOversize">
            <div class="uploadDemoP">
              <div class="uploadDemo">
                <img src="@/assets/img/guohuimian@2x.png" alt="" />
              </div>
            </div>
          </van-uploader>
        </div>
      </card-wrap>
      </div>
      <card-wrap class="mt8">
        <div class="">
          <div class="flexBox">
            <div class="context">
              <div class="imgBox">
                <img src="@/assets/img/shengfenzheng@2x.png" alt="" />
              </div>
              <div class="imgTip">标准拍摄</div>
            </div>
            <div class="context">
              <div class="imgBox transRight5">
                <img src="@/assets/img/shengfenzheng@2x.png" alt="" />
              </div>
              <div class="imgTip">边框缺失</div>
            </div>
            <div class="context">
              <div class="imgBox">
                <img src="@/assets/img/shengfenzheng-mohu@2x.png" alt="" />
              </div>
              <div class="imgTip">照片模糊</div>
            </div>
            <div class="context">
              <div class="imgBox">
                <img src="@/assets/img/sfz-shanguang@2x.png" alt="" />
              </div>
              <div class="imgTip">闪光强烈</div>
            </div>
          </div>
          <div class="mt20 idCardTip">
            建议使用扫描仪或高拍仪，请勿使用屏幕截图。请完整扫描每页材料，保持图片清晰可辨，分辨率在200*200以上，身份证需扫描正反两面，每张图片大小请控制在10MB以内且为jpg格式
          </div>
        </div>
      </card-wrap>
      <!-- <button-group
        :buttonList="buttonList"
        @clickBack="clickBack"
        @goBack="goBack"
        @nextStep="submit"
      ></button-group> -->
      <div class="next">
        <van-button type="info" block class="nextBtn" @click="prevClick" >返回</van-button>
        <van-button type="info" block class="nextBtn" @click="savePrevClick" v-if="!Boolean($route.query.disabled)">保存并返回</van-button>
        
        <!-- <van-button type="info" block class="nextBtn" @click="nextClick">下一步</van-button> -->
      </div>
  </div>
</template>

<script>
import tip from "./component/tip.vue";
import cardWrap from "./component/cardWrap.vue";
import {uploadPictures,getFileUrl} from "@/api/common/index"// 上传
// import { getToken } from '@/utils/auth' // get token from cookie

export default {
  name: "IDCard",
  components: { tip,cardWrap },
  data() {
    return {
      fileList1: [], // 正面
      fileList2: [], // 反面
      idCard: {
        identityCardFront: '',
        identityCardBack: ''
      }
    };
  },
  created() {
   this.idCard = JSON.parse(JSON.stringify(this.$store.state.idCard))
    if (this.idCard.identityCardFront && this.idCard.identityCardBack) { // 设置回显数据
      this.fileList1 = [{url: ''}]
      this.fileList2 = [{url: ''}]
      this.getShowUrl(this.idCard.identityCardFront, this.fileList1)
      this.getShowUrl(this.idCard.identityCardBack, this.fileList2)
    }
    //
  },
  methods: {
    onOversize() {
      this.$toast.fail("文件大小不能超过 10MB");
    },
    // 上传身份证头像面 正面
    onfrontRead(file) {
      let data = new FormData();
      data.append("files", file.file);
      data.append("token", this.$store.state.token);
      uploadPictures(data).then((res) => {
        this.idCard.identityCardFront = res[0]
        this.getShowUrl(res[0], this.fileList1)
      });
    },
    // 上传身份证国徽面 反面
    onreverseSideRead(file) {
      let data = new FormData();
      data.append("files", file.file);
      data.append("token", this.$store.state.token);
      uploadPictures(data).then((res) => {
        this.idCard.identityCardBack = res[0]
        this.getShowUrl(res[0], this.fileList2)
      });
    },
    // 获取详细地址 key: 参数  showkey：展示的data
    getShowUrl(key,showkey) {
      getFileUrl({objectKey: key}).then(datas=>{
        showkey[0].url = datas
      })
    },
    // 保存并返回
    savePrevClick() {
      if (!this.fileList1.length) {
        this.$toast({
          message: "上传身份证头像面",
          position: "top",
        });
        return;
      }
      if (!this.fileList2.length) {
        this.$toast({
          message: "上传身份证国徽面",
          position: "top",
        });
        return;
      }
      this.$store.commit('setIdCard', this.idCard);
      this.$router.back()

    },
    // 返回
    prevClick() {
      this.$store.commit('setIdCard',this.$store.state.idCard);
      this.$router.back()
    },
  },
};
</script>
<style scoped>
.idCard {
  box-sizing: border-box;
  padding-bottom: 60px;
}
.uploader {
  position: relative;
}
.uploadDemoP::before,
.uploadDemoP::after {
  position: absolute;
  width: 10px;
  height: 10px;
  content: "";
  border-top: 3px solid #d62d27;
  top: 0;
}
.uploadDemoP::before {
  border-left: 3px solid #d62d27;
  left: 0;
}
.uploadDemoP::after {
  border-right: 3px solid #d62d27;
  right: 0;
}
.uploadDemo {
  padding: 18px 15px 12px;
  position: relative;
}
.uploadDemo::before,
.uploadDemo::after {
  position: absolute;
  width: 10px;
  height: 10px;
  content: "";
  border-bottom: 3px solid #d62d27;
  bottom: 0;
}
.uploadDemo::before {
  border-left: 3px solid #d62d27;
  left: 0;
}
.uploadDemo::after {
  border-right: 3px solid #d62d27;
  right: 0;
}
.uploadDemo img {
  display: block;
  width: 100%;
}
.context {
  width: calc(25% - 5px);
}
.context .imgBox {
  padding: 10px 6px;
  background: #f5f5f5;
  border-radius: 5px;
  overflow: hidden;
}
.context img {
  display: block;
  width: 100%;
}
.transRight5 img {
  transform: translateX(16px);
}
.imgTip {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 1em;
  margin-top: 10px;
  text-align: center;
}
.idCardTip {
  font-size: 13px;
  font-weight: 400;
  color: #999999;
  line-height: 18px;
  text-align: justify;
}
.uploader /deep/ .van-uploader__preview-image {
  width: 250px;
  height: 165px;
}
.uploader /deep/ .van-uploader__preview-image img {
  width: 250px;
  height: 165px;
}
.uploader {
  position: relative;
}
.uploader::before {
  position: absolute;
  left: -8px;
  color: #ee0a24;
  font-size: 14px;
  content: '*';
}


.next {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 60px;
  padding: 0 10px;
  background-color: #fff;
}
.next .nextBtn {
  background-color: red;
  border: none;
  font-size: 18px;
  font-weight: bold;
  border-radius: 10px;

}
.next .nextBtn:nth-child(2) {
  margin: 0 10px;
}

.next .nextBtn:nth-child(1) {
  background-color: #fff;
  border: 1px solid red;
  color: red;
  border-radius: 10px;
  width: 450px;
}

/* .next .nextBtn:not(:first-child) {
  background-color: #fff;
  border: 1px solid red;
  color: red;
 
} */
</style>